import React, { useState } from 'react';
import Modal from 'react-modal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCalendarAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';

import axios from 'axios';
import LoadingScreen from '../../../LoadingScreen';

const customModalStyles = {
  content: {
    width: '80%', 
    //height: '90%',
    maxWidth: '600px',
    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    //justifyContent: 'center', // Center vertically
    alignItems: 'center', // Center horizontally
    borderRadius: '1%',
  },
};

const AddInstitutionModal = ({ isOpen, onRequestClose, onAddInstitution }) => {
  const [name, setName] = useState('');
  const [onBoardingYear, setOnBoardingYear] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [genType, setGenType] = useState('');
  const [logo, setLogo] = useState({});

  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [registrationError, setRegistrationErrorMessage] = useState('');

  const [isNetworkLoading, setIsNetworkLoading] = useState(false);

  
  //
  const currentYear = new Date().getFullYear();
  const pastYears = Array.from({ length: 7 }, (_, i) => currentYear - i);
  //const pastYears = Array.from({ length: 5 }, (_, i) => currentYear - i).filter(year => year !== currentYear); // Exclude current year
  
  //const futureYears = Array.from({ length: 5 }, (_, i) => currentYear + i);
  // const years = [...pastYears, ...futureYears];
  const years = [...pastYears];
  //



  const clearFields = () => {
    //
    setName('');
    setOnBoardingYear('');
    setContactEmail('');
    setGenType('');  
    setLogo({});
  
    setRegistrationStatus(null);
    setIsModalOpen(false);
  
    setRegistrationErrorMessage('');
          //
  }

  const handleOptionChange = (event) => {
    const selectedValue = event.target.value;
    setGenType(selectedValue);
    //alert(selectedValue);
    //alert(genType);
  };


    // Function to validate email format
    const isValidEmail = (email) => {
      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(email);
  };

  const hitAddInstitutionEndpoint = async () => {
    //onAddInstitution(institutionName);
    //setInstitutionName('');

    // Validate email before proceeding
    if (!isValidEmail(contactEmail)) {
      alert('Invalid email address');
      //setRegistrationStatus("Invalid email address");
      //setIsModalOpen(true);
      return;
    }

    setRegistrationErrorMessage('');
    setIsNetworkLoading(true);

    // alert(
    //   'name: ' + name +
    //     '\nonBoardingyear: ' + onBoardingYear +
    //     '\ncontactEmail: ' + contactEmail +
    //     '\ngenType: ' + genType +
    //     '\nlogo: ' + logo.name 
    // );

    if (
      //institutionName  == ''  ||
      //onboardingYear == '' ||
      //email == '' ||
      genType == ''
      ) {
      alert("Please select a type.");
      setIsNetworkLoading(false);
      return;
    }


    try {
      const token = localStorage.getItem('token')
      //alert(token);

      const formData = new FormData();
      formData.append('name', name);
      formData.append('onBoardingyear', onBoardingYear);
      formData.append('contactEmail', contactEmail);
      formData.append('genType', genType);

      // Append the actual file to the formData
      formData.append('logo', logo);

      const response = await axios.post("https://gacsstage.zaptrance.ng/api/admin/institutions", formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          //"Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setIsNetworkLoading(false);

      if (response.data.success) {
        // Registration was successful, you can handle the response here
        //alert("ok");
        setRegistrationStatus("Registration Successful");
        //setIsModalOpen(true);
        console.log('Registration successful:' + response.data.message);


        clearFields();

        // Close the modal
        //onRequestClose();
        onAddInstitution();

        // You can also redirect the user to a confirmation page or do any other actions.
      } else {
        // Handle the case where registration was not successful
        alert("not ok");
        setRegistrationStatus("Registration Failed");
        setIsModalOpen(true);
        console.error('Registration failed:' + response.data);
        setRegistrationErrorMessage(response.data);
      }
    } catch (error) {
      setIsNetworkLoading(false);

      setRegistrationStatus("Registration Failed");
  console.error('Registration Failed:'+ error.message);

  if (error.response && error.response.data && error.response.data.data) {
    const dataKeys = Object.keys(error.response.data.data);

    if (dataKeys.length > 0) {
      // Construct an error message from the data keys
      const errorMessage = dataKeys
        .map(key => {
          const messages = error.response.data.data[key];
          //return `${key}: ${messages.join(', ')}`;
          return `${messages.join(', ')}`;
        })
        .join('\n');

      setRegistrationErrorMessage(errorMessage);
    } else {
      // If there are no data keys, set a generic error message
      setRegistrationErrorMessage('An error occurred during registration.');
    }
  } else {
    // Handle other error cases if needed
    setRegistrationErrorMessage('An error occurred during registration.');
  }

    }

  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
  if (file) {
    setLogo(file);
    //alert('File selected: ' + file.name);
    //alert(file.name);
  } else {
    alert('No file selected');
  }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Add Institution Modal"
      style={customModalStyles}
    >
      <div className="flex justify-between items-center w-full px-2 pt-4">
  <div className="flex items-center">
    <FontAwesomeIcon icon={faBuilding} color="black" className='mr-6' size="2x"/>
    <h2 className='text-xl'>Create Institution</h2>
  </div>
  <div>
    <button
      //onClick={onRequestClose}
      onClick={() => {
        onRequestClose();
        clearFields();
        setRegistrationErrorMessage('');
      }}
      className="border p-2"
      style={{
        background: 'none',
        cursor: 'pointer',
        borderRadius: '50%',
        borderColor: 'black',
        display: 'inline-block',
        width: '30px',
        height: '30px',
        padding: '0',
      }}
    >
      <span aria-hidden="true">
        <FontAwesomeIcon icon={faTimes} color="black" />
      </span>
    </button>
  </div>
</div>


      <div className="w-full px-2 pt-4">
        <div className="flex flex-col py-2">
          <label>Institution Name</label>
          <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Please enter your full name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div className="flex flex-col py-2">
          <label>OnBoarding Year</label>
          {/* <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Select Year"
            maxLength='4'
            value={onBoardingYear}
            onChange={(e) => setOnBoardingYear(e.target.value)}
          /> */}
          <select
                style={{ backgroundColor: '#EDF2F6', width: '100%' }}
                className="rounded-lg mt-2 p-2 focus"
                value={onBoardingYear}
                // readOnly={additionalVariable === 'noEdit'}
                onChange={(e) => setOnBoardingYear(e.target.value)}>
                  <option value="">Select Year</option>
                {years.map(year => (
                    <option key={year} value={year}>{year}</option>
                ))}
            </select>
        </div>

        <div className="flex flex-col py-2">
          <label>Email</label>
          <input
            style={{ backgroundColor: '#EDF2F6', width: '100%' }}
            className="rounded-lg mt-2 p-2 focus"
            type="text"
            placeholder="Please enter your email"
            value={contactEmail}
            onChange={(e) => setContactEmail(e.target.value)}
          />
        </div>

        <div className="flex flex-col py-2">
          <label>Institution Logo</label>
          <div className="flex flex-col py-2 px-4">
            
            <input
              style={{ backgroundColor: '#EDF2F6', width: '100%' }}
              type="file"
              id="logoInput"
              accept=".jpg, .jpeg, .tif, .tiff, .bmp, .gif, .png"
              onChange={handleLogoChange}
            />
          </div>
        </div>

        <div className="flex flex-col py-2">
          {/* <label>Select Option</label> */}
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <label style={{ flex: '1', textAlign: 'center' }}>
              <input type="radio" name="option" value="qrCodeOnly" className='mr-2' 
              checked={genType === 'qrCodeOnly'} // Check if this option is selected
              onChange={handleOptionChange}
              />
              QR Code Only
            </label>

            <label style={{ flex: '1', textAlign: 'center' }}>
              <input type="radio" name="option" value="certificateOnly" className='mr-2' 
              checked={genType === 'certificateOnly'} // Check if this option is selected
              onChange={handleOptionChange}
              />
              Certificate Only
            </label>

            <label style={{ flex: '1', textAlign: 'center' }}>
              <input type="radio" name="option" value="both" className='mr-2' 
              checked={genType === 'both'} // Check if this option is selected
              onChange={handleOptionChange}
              />
              Both
            </label>
          </div>
        </div>

        <div className='text-center' style={{ display: 'flex', justifyContent: 'center' }}>
        <p className='text-center mb-4 text-red-500'
        style={{ 
          //color: 'red',//'#990000', 
          fontSize: '12px' }}>{registrationError}</p>
      </div>


<div 
//className="text-right" 
style={{ position: 'absolute', bottom: '10px', right: '10px' }}
>
  <button
    className="px-6 py-3 m-4"
    style={{
      width: '200px',
      backgroundColor: '#095918',
      borderRadius: '8px',
      padding: '10px 20px',
      color: 'white',
      border: 'none',
    }}
    onClick={hitAddInstitutionEndpoint}
  >
    {isNetworkLoading ? (
                      <LoadingScreen />
                    ) : (
                      'Save'
                    )}
    
  </button>
</div>



      </div>
    </Modal>
  );
};

export default AddInstitutionModal;
